import axios from "axios";
import Cookies from "js-cookie";

const axiosClient = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  headers: {
    Accept: "application/json",
  },
});

axiosClient.interceptors.request.use(
  async (config) => {
    const token = Cookies.get("spirulina_website_security");
    if (token) {
      config.headers["Authorization"] = "Bearer " + token;
    } else {
      delete config.headers["Authorization"];
    }
    return config;
  },
  (err) => Promise.reject(err),
);

// RESPONSE INTERCEPTOR
axiosClient.interceptors.response.use(
  (response) => response,

  async (error) => {
    if (error?.response?.status === 401) {
      Cookies.remove("spirulina_website_security");

      Cookies.remove("user_id");

      localStorage.clear();
      sessionStorage.clear();

      const publicRoutes = ["/privacy", "/terms", "/return-policy", "/refund-policy", "/shipping-policy"];

      if (
        window.location.pathname !== "/" &&
        !publicRoutes.includes(window.location.pathname)
      ) {
        window.location.href = "/";
      }
    }

    // 403 Forbidden
    if (error?.response?.status === 403) {
      const message =
        error?.response?.data?.message || "Your account is inactive.";

      sessionStorage.setItem("inactive_message", message);
      sessionStorage.setItem("show_inactive_modal", "true");

      Cookies.remove("spirulina_website_security");
      Cookies.remove("user_id");
      localStorage.removeItem("persist:root");

      const publicRoutes = ["/privacy", "/terms", "/return-policy", "/refund-policy", "/shipping-policy"];

      // window.location.replace("/");
      if (!publicRoutes.includes(window.location.pathname)) {
        window.location.replace("/");
      }
    }

    return Promise.reject(error);
  },
);

export default axiosClient;
